import { createRoutine } from 'redux-saga-routines'
import { FETCH_SEAT_MAP } from './types'

export const fetchSeatMap = createRoutine<{ performanceId: string }>(
  FETCH_SEAT_MAP
)
